// extracted by mini-css-extract-plugin
module.exports = {"wrap":"gd","contentWrapCtaDefault":"hd","disabled":"id","contentWrapCtaWhite":"jd","promos":"kd","lazyPromo":"ld","mainContent":"md","headingText":"nd","copy":"od","subtext":"pd"};